import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import addSimpleOpacityAnimation from '../lib/add-simple-opacity-animation';

gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.about-page-mission-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const scheme = query('.circle-scheme');
    const columns = queryAll('.circle-scheme-col');
    const areas = queryAll('.area');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: sectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(scheme, timeline);
    addSimpleOpacityAnimation(timeline, scheme, 0.1);
    addSimpleOpacityAnimation(timeline, columns, 0.2);
    const activeState = (parent, wrap) => {
        columns.forEach((item) => {
            const itemText = item.querySelector('.plaintext');
            const itemArea = item.querySelector('.area');
            item.classList.remove('active');
            itemText.setAttribute('aria-hidden', 'true');
            itemArea.setAttribute('aria-expanded', 'false');
        });
        const parentText = parent.querySelector('.plaintext');
        const parentArea = parent.querySelector('.area');
        parentText.setAttribute('aria-hidden', 'false');
        parentArea.setAttribute('aria-expanded', 'true');
        parent.classList.toggle('active');
        wrap.classList.toggle('active');
    };
    const inactiveState = (parent, wrap) => {
        const parentText = parent.querySelector('.plaintext');
        const parentArea = parent.querySelector('.area');
        parentText.setAttribute('aria-hidden', 'true');
        parentArea.setAttribute('aria-expanded', 'false');
        parent.classList.toggle('active');
        wrap.classList.remove('active');
    };

    areas.forEach((item) => {
        const wrap = item.closest('.circle-scheme');
        const parent = item.closest('.circle-scheme-col');

        item.addEventListener('click', () => {
            // eslint-disable-next-line no-unused-expressions
            parent.classList.contains('active') ? inactiveState(parent, wrap) : activeState(parent, wrap);
        });
        item.addEventListener('keydown', (e) => {
            if (e.code.toLowerCase() === 'space' || e.code.toLowerCase() === 'enter') {
                // eslint-disable-next-line no-unused-expressions
                parent.classList.contains('active') ? inactiveState(parent, wrap) : activeState(parent, wrap);
            }
        });
    });
};

export { sectionSelector, sectionCallBack };
